var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-top"},[(_vm.currentRouteName === 'AdminMain')?_c('h3',[_vm._v("推文清單")]):_c('h3',[_vm._v("使用者列表")])])}
var staticRenderFns = []

export { render, staticRenderFns }